import {Component} from '@angular/core';
import {IPiwikConfig, piwikConfig} from './piwik.config';

@Component({
    selector: 'ba-piwik',
    template: '',
    standalone: false
})
export class PiwikScriptComponent {

  private readonly _config: IPiwikConfig = piwikConfig;

  constructor() {
    if (this._config.trackingActivated) {
      this._insertPiwikScript();
    }
  }

  /**
   * Fuegt das PiwikScript Element am Ende vom body Tag ein.
   */



  private _insertPiwikScript(): void {
    // -- Abbrechen, falls script bereits im document existiert
    if (this._scriptExisits(this._config.scriptSrc)) {
      return;
    }
    const _mtm = (window as any)._mtm = (window as any)._mtm || [];
    _mtm.push({'mtm.startTime': Date.now(), 'event': 'mtm.Start'});
    // -- Script erzeugen
    const piwikScriptElement: HTMLScriptElement = document.createElement('script');
    piwikScriptElement.type = 'text/javascript';
    piwikScriptElement.async = true;
    piwikScriptElement.defer = true;
    piwikScriptElement.src = this._config.scriptSrc;

    // -- Am Ende vom Body einfügen
    document.body.appendChild(piwikScriptElement);
  }

  /**
   * Prüft ob ein Script-Tag mit der "url" bereits im DOM existiert
   * @param url
   * @private
   */
  private _scriptExisits(url: string): boolean {
    return document.querySelectorAll(`script[src="${url}"]`).length > 0;
  }

}
